var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBatteryOf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.3333H23.3333V18.6667H25.6667V11.6667H23.3333V7H0V23.3333ZM2.33333 21V9.33333H21V21H2.33333ZM4.66667 18.6667H7V11.6667H4.66667V18.6667ZM9.33333 18.6667H11.6667V11.6667H9.33333V18.6667ZM14 18.6667H16.3333V11.6667H14V18.6667Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBatteryOf);
export default __webpack_public_path__ + "static/media/ic-battery-of.4da833d42ecdedb98576bf3938a73ed0.svg";
export { ForwardRef as ReactComponent };